<style>
  header {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1.5rem;
    position: relative;
  }

  .container {
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
    z-index: 10;
  }

  .header-bar {
    border-bottom: 1px solid var(--separator);
    padding-bottom: 1.5rem;
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .header-label {
    font-family: "Inter", sans-serif;
    color: var(--muted);
    font-size: 0.75rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
  }

  h1 {
    font-family: "Bodoni Moda", serif;
    font-size: 4.5rem;
    font-style: italic;
    font-weight: 400;
    line-height: 0.85;
    margin-bottom: 3rem;
    background: none;
    line-height: 1;
  }

  h1 span {
    margin-left: 3rem;
  }

  .video-container {
    width: 100%;
    max-width: 1280px;
    margin: 3rem auto 0;
  }

  figcaption {
    display: flex;
    justify-content: space-between;
    margin-top: 0.75rem;
    border-top: 1px solid var(--separator);
    padding-top: 0.5rem;
  }

  figcaption span {
    font-family: "Inter", sans-serif;
    color: var(--muted);
    font-size: 0.625rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  @media (min-width: 768px) {
    header {
      padding: 3rem;
    }

    h1 {
      font-size: 8rem;
    }

    h1 span {
      margin-left: 8rem;
    }
  }

  @media (min-width: 1024px) {
    header {
      padding: 6rem;
    }
  }
</style>

<script>
  import VideoPlayer from "./components/VideoPlayer.svelte";

  let { lightboxItems = $bindable([]), openLightbox = $bindable(() => {}) } =
    $props();

  const previewSrc = "./proposal_trimmed_2.mp4";
  const videoSrc =
    "https://strieb.zip/proposal/Proposal%20GoPro%20SuperCut.mp4";
  const videoPoster = "";

  lightboxItems = [
    ...lightboxItems,
    {
      type: "video",
      src: videoSrc,
      poster: videoPoster,
    },
  ];
</script>

<header>
  <div class="container">
    <div class="header-bar">
      <span class="header-label">The Proposal</span>
      <span class="header-label">11.16.2025</span>
    </div>

    <h1>
      Jacob <br />
      <span>&amp; Amy</span>
    </h1>
  </div>

  <figure class="video-container">
    <VideoPlayer
      {previewSrc}
      fullSrc={videoSrc}
      poster={videoPoster}
      onclick={() => openLightbox(0)}
    />
    <figcaption>
      <span>3:50 PM</span>
    </figcaption>
  </figure>
</header>
